export default "__VITE_ASSET__D0k8oU5p__"